import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../../assets/images/editinput.svg";
import { TextArea } from "@appkit4/react-components/field";
import { Tab, Tabs } from "@appkit4/react-components/tabs";
import { Select } from "@appkit4/react-components/select";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import useHttp from "../../../../hooks/useHttp";
import APIService from "../../../../services/apiAxiosService";
import PropTypes from 'prop-types'
import { Tooltip } from '@appkit4/react-components/tooltip';
import UploadForm from "../../../Common/UploadForm";
import { getMimetype } from "../../../Common/FileValidation";

export default function RemediationPlan(prop) {
  let { updateIssueId, View, reload } = prop;
  const [currentTab, setCurrentTab] = useState("1");
  const [provideResponseValue, setProvideResponseValue] = useState("");
  const [errorRemidiationplan, setErrorRemidiationplan] = useState("");
  const [remediationPlan, setRemediationPlan] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [workPerformed, setWorkPerformed] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorWorkPerformed, setErrorWorkPerformed] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [comments, setComments] = useState("");
  const [commentsFormat, setCommentsFormat] = useState(false);
  const { sendRequest: manageViewIssueAPI } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: saveEvidence } = useHttp();
  const { sendRequest: downloadAPI } = useHttp();
  const [formData, setFormData]=useState({
    OtherDocs: [],
  });
  

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };

  function formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("-");
  }

  const manageViewIssueResponse = (data) => {
    if (data.CODE) {
      prop.handleBack();
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: updateIssueId && updateIssueId.vendor_id,
        paramcontent: "save the issue",
        paramnextroleid: 4,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: data.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
      displayToastMessage(data.MSG, "success");
      reload();
    } else {
      let Msg = "Action failed. Please try again!";
      prop.handleBack();
      displayToastMessage(Msg, "error");
    }
  };

  const handelSubmit = async (values, { resetForm }) => {
    if (!commentsFormat) {
      let issueData = {
        Issue_ID: updateIssueId && updateIssueId.issue_id,
        Vendor_ID: updateIssueId && updateIssueId.vendor_id,
        RemediationPlan: updateIssueId && updateIssueId.remediationplan,
        Title: updateIssueId && updateIssueId.title_action,
        Description: updateIssueId && updateIssueId.description,
        StartDate: values.StartDate,
        EndDate: values.EndDate,
        WorkPerformed: updateIssueId && updateIssueId.workperformed,
        Issue_Comments: comments,
        Role_ID: Number(sessionStorage.getItem("roleId")),
        Created_By: Number(sessionStorage.getItem("userId")),
        email:sessionStorage.getItem("email"),
        issue_action_id:updateIssueId?.issue_action_id,
        analystEmail: updateIssueId && updateIssueId.analystemail,
        analystName: updateIssueId && updateIssueId.analyst_name

      };
      if (provideResponseValue != 8) {
        issueData.IssueStatus = 4;
      } else {
        issueData.IssueStatus = provideResponseValue;
      }
      if(formData.OtherDocs.length!=0)
      {
        issueData.fileName=formData;

      }else  if (updateIssueId?.filestructure){
       
      // Parse the JSON string  
let parsedData = JSON.parse(updateIssueId?.filestructure);  
  
// Create the desired object structure  
let fileName = {  
    "OtherDocs": parsedData  
};  
  
issueData.fileName=fileName;

      }else{
        // Create the desired object structure  
let fileName = {  
  "OtherDocs": null  
}; 
        issueData.fileName=fileName;
      }
      await manageViewIssueAPI(
        APIService.manageViewIssue(issueData),
        manageViewIssueResponse,
        (error) => {
          console.log("Error", error);
          prop.handleBack();
          let Msg = "Action failed. Please try again!";
          displayToastMessage(Msg, "error");
        }
      );
    }
  };

  let validateInputFields = (value) => {
    let reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  };

  const handleRemediationPlan = (e) => {
    if (e.target.value === "") {
      setErrorRemidiationplan("");
      setRemediationPlan(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorRemidiationplan("");
        setRemediationPlan(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorRemidiationplan("Special characters are not allowed");
      }
    }
  };

  const handleChangeTitle = (e) => {
    if (validateInputFields(e.target.value)) {
      setErrorTitle("");
      setTitle(e.target.value);
    } else {
      setIsErrorMessageShown(true);
      setErrorTitle("Special characters are not allowed");
    }
  };

  const handleChangeDescription = (e) => {
    if (validateInputFields(e.target.value)) {
      setErrorDescription("");
      setDescription(e.target.value);
    } else {
      setIsErrorMessageShown(true);
      setErrorDescription("Special characters are not allowed");
    }
  };

  const handleChangeWorkPerformed = (e) => {
    if (validateInputFields(e.target.value)) {
      setErrorWorkPerformed("");
      setWorkPerformed(e.target.value);
    } else {
      setIsErrorMessageShown(true);
      setErrorWorkPerformed("Special characters are not allowed");
    }
  };

  let initialValues = {
    RemediationPlan:
      updateIssueId?.remediationplan,
    Title:  updateIssueId?.title_action,
    Description:
      updateIssueId?.description,
    StartDate: formatDate(
       updateIssueId?.startdate
    ),
    EndDate: formatDate(
      updateIssueId?.enddate 
    ),
    WorkPerformed:
       updateIssueId?.workperformed,
    Comment: "",
  };
  const handleProvideResponse = (value) => {
    setProvideResponseValue(value);
  };
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };

  function MimeTypeOtherDoc(files) {
    return new Promise((resolve, reject) => {

      files.forEach((uploadedfile, index) => {
        if (uploadedfile.name && !uploadedfile.isParsed) {
          const fileReader = new FileReader();
          fileReader.readAsArrayBuffer(uploadedfile);

          fileReader.onload = function (e) {
            // get file content
            const uint = new Uint8Array(e.target.result).subarray(0, 4);
            let bytes = [];
            uint.forEach((byte) => {
              bytes.push(byte.toString(16));
            });
            const hex = bytes.join("").toUpperCase();
            
               resolve({hex: hex, type: uploadedfile.type});
             
          };
          fileReader.onerror = reject;

        }
      });
    });
  }

  


function toBase64OtherDocs(files) {
  return new Promise((resolve, reject) => {
    const otherFiles = [];
    files.forEach((uploadedfile, index) => {
      if (uploadedfile.name && !uploadedfile.isParsed) {
        const reader = new FileReader();
        reader.readAsDataURL(uploadedfile);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            
            otherFiles.push({
             base64File: reader.result,
              name: uploadedfile.name,
              fileType: uploadedfile.type,
              FileSize:uploadedfile.size,
             unique_name : `${sessionStorage.getItem("userId")}_${Math.floor(Math.random() * 10)}_${uploadedfile.name}`,
            });
            if (index === files.length - 1) {
              resolve(otherFiles);
            }
          }
        };
        reader.onerror = reject;
      }
    });
  });
}

const responseHandlerUpload = (result) => {
  if (result.CODE) {
    displayToastMessage(result.MSG, "success");
  }
};

const fileHandleUpload = async (newFile) => {
  saveEvidence(
    APIService.saveEvidenceIssue(newFile),
    responseHandlerUpload,
    errorHandler
  );
};

const errorHandler = () => {
  displayToastMessage("Something went wrong, Please try again!", "error");
  setFormData({
    ...formData,
    OtherDocs: [],
  });
};

const otherDocs = (fileList) => {
  if(fileList.length<=5){
  MimeTypeOtherDoc(fileList).then((img) => {
    if (getMimetype(img.hex, img.type)) {
      toBase64OtherDocs(fileList).then((fileData) => {
        const newObj = { ...fileData[0], hex: img.hex };
        setFormData({
          ...formData,
          OtherDocs: [...formData.OtherDocs, ...fileData],
        });
        fileHandleUpload([newObj]);

      });
    } else {
      displayToastMessage("Please upload a valid, non-empty file.",'error');
      setFormData({
        ...formData,
        OtherDocs: [],
      });
    }
  });
}else{
  displayToastMessage("Only 5 file can be upload.",'error');
  setFormData({
    ...formData,
    OtherDocs: [...formData.OtherDocs],
  });
}
};

const splitData=updateIssueId?.evidencedetails?.split(',');

  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data,'issue'),
      (res) => downloadResponseHandler(res, fileName),
      (err) => {
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };
  return (
    <div>
      <div className="row text-end">
        <div className="col-md-12 ">
          <span className="cv-input-label  me-5">
            Issue ID : {"ISSUE"}
            {updateIssueId && updateIssueId.issue_id}{" "}
          </span>
          <span className="cv-input-label me-4">
            Status :{" "}
            <span className="upadte-status Close-status status-pading me-4">
              {" "}
              {updateIssueId?._status}
            </span>
          </span>
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={prop.handleBack}
          ></span>
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={handelSubmit}
        validationSchema={Yup.object().shape({
          RemediationPlan: Yup.string()
            .required("Remediation plan is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ),
        })}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (
            <div className="">
              {updateIssueId && (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="ThirdPartyNameRemediation" className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="ThirdPartyName"
                          type="text"
                          id="ThirdPartyNameRemediation"
                          value={updateIssueId.vendor_name}
                          onChange={handleChange("ThirdPartyName")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          placeholder="Please enter third party name"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="AssessmentRemediation" className="cv-input-label">
                          Assessment <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="AssessmentID"
                          type="text"
                          id="AssessmentRemediation"
                          value={updateIssueId.assessment_name}
                          onChange={handleChange("AssessmentID")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          placeholder="Please enter assessment"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="IssueDetailsRemediation" className="cv-input-label">
                          Issue Details <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDetails"
                          type="text"
                          id="IssueDetailsRemediation"
                          value={updateIssueId.issue_details}
                          onChange={handleChange("IssueDetails")}
                          onBlur={handleBlur}
                          className="cv-input-field pl-1"
                          placeholder="Please enter issue details"
                          disabled
                        />
                         <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        className="tooltipData"
        appendAfterTarget={true}
        content={updateIssueId.issue_details}
      > <img alt="edit" src={Edit} className="edit-input" /> </Tooltip>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="creationDateRemediation" className="cv-input-label">
                          Creation Date{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="CreationDate"
                          type="date"
                          id="creationDateRemediation"
                          value={formatDate(updateIssueId.created_date)}
                          onChange={handleChange("CreationDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="issueDueDateRemediation" className="cv-input-label">
                          Issue Due Date{" "}
                          <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDueDate"
                          type="date"
                          id="issueDueDateRemediation"
                          value={formatDate(updateIssueId.issuedue_date)}
                          onChange={handleChange("IssueDueDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <Tabs
                      defaultValue={currentTab}
                      value={currentTab}
                      onChange={handleTabs}
                      className="a-tab-item-padding-10"
                    >
                      
                      <Tab value="3" label="Control/Question Mapping">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlQuestionIDRemediation" className="cv-input-label">
                              Control/ Question ID <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="ControlName"
                              type="text"
                              id="ControlQuestionIDRemediation"
                              placeholder="ControlQuestionID"
                              value={updateIssueId.controlquestionid}
                              onChange={handleChange("ControlQuestionID")}
                              onBlur={handleBlur}
                              className="cv-input-field ml-3"
                              disabled
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                        </div>

                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlNameRemediation" className="cv-input-label">
                              Control Name{" "}
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="ControlName"
                              type="text"
                              id="ControlNameRemediation"
                              value={updateIssueId.control_name}
                              onChange={handleChange("ControlName")}
                              onBlur={handleBlur}
                              className="cv-input-field pl-1"
                              placeholder="Please enter control name"
                              disabled
                            />
                             <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={updateIssueId.control_name}
      >
                          <img alt="edit" src={Edit} className="edit-input" /></Tooltip>
                          </div>
                        </div>
                      </Tab>
                      <Tab value="4" label="Remediation Plan">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="Remediation Plan" className="cv-input-label">
                              Remediation Plan
                            </label>
                            <textarea
                              name="RemediationPlan"
                              type="text"
                              placeholder="Please enter RemediationPlan"
                              value={updateIssueId.remediationplan}
                              onChange={handleRemediationPlan}
                              className="cv-input-field"
                            />
                            <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        className="tooltipData"
        appendAfterTarget={true}
        content={values.RemediationPlan}
      > <img alt="edit" src={Edit} className="edit-input" /> </Tooltip>
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorRemidiationplan}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-6">
                         
                         <UploadForm
                   isMultiple={true}
                   onUpload={otherDocs}
                   title="Evidence"
                   tooltipTitle="Evidence"
                   existingFiles={[
                     ...(formData?.OtherDocs?.map((item) => {
                       return {
                         name: item?.name,
                         size: item?.FileSize,
                         isParsed: true,
                       };
                     }) ?? {}),
                   ]}
                   onDeleteAll={(fileName) => {
                     setFormData({
                       ...formData,
                       OtherDocs: fileName
                         ? formData.OtherDocs.filter(
                             (item) => item.name !== fileName
                           )
                         : [],
                     });
                   }}
                   accept={".JPG,.PNG,.PDF,.xls,.xlsx,.pdf,.txt,.csv,.png,.jpeg,.jpg,.ppt,.pptx,.doc,.docx"}
                 />
                 <span className="validationMessage">Maximum files allowed per claim : 5 files <br/>Maximum file size per file allowed : 5 MB <br/>Allowed file types:.JPG,.PNG,.PDF,.xls,.xlsx,.pdf,.txt,.csv,.png,.jpeg,.jpg,.ppt,.pptx,.doc,.docx</span>
                  {splitData?.map((val,i)=>{
                           return  <div onClick={()=>getDownloadFile(val.split('#$%')[1],val.split('#$%')[0])} className="hyperText">{val.split('#$%')[0]} </div>
 
                           })}
                         </div>
                      </Tab>
                      <Tab value="5" label="Add Action">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="Title" className="cv-input-label">Title</label>
                            <input
                              name="Title"
                              type="text"
                              placeholder="Please enter title"
                              value={updateIssueId.title_action}
                              onChange={handleChangeTitle}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorTitle}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="Description" className="cv-input-label">
                              Description
                            </label>
                            <input
                              name="Description"
                              type="Description"
                              id="Description"
                              placeholder="Please enter description"
                              value={updateIssueId.description}
                              onChange={handleChangeDescription}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorDescription}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="StartDateRemediation" className="cv-input-label">Start Date</label>
                            <input
                              name="StartDate"
                              type="date"
                              id="StartDateRemediation"
                              placeholder="StartDate"
                              value={formatDate(updateIssueId.startdate)}
                              onChange={handleChange("StartDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="EndDateRemediation" className="cv-input-label">End Date</label>
                            <input
                              name="EndDate"
                              type="date"
                              id="EndDateRemediation"
                              placeholder="EndDate"
                              value={formatDate(updateIssueId.enddate)}
                              onChange={handleChange("EndDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="Work Performed" className="cv-input-label">
                              Work Performed
                            </label>
                            <input
                              name="WorkPerformed"
                              type="text"
                              id="WorkPerformed"
                              placeholder="Please enter work performed"
                              value={updateIssueId.workperformed}
                              onChange={handleChangeWorkPerformed}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorWorkPerformed}
                            </span>
                          </div>
                        </div>
                      </Tab>
                      <Tab value="6" label="Approval">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="approvalRemediation" className="cv-input-label">
                              Approval{" "}
                              <span className="asterisk-required">*</span>
                            </label>

                            <input
                              name="Approval"
                              type="text"
                              id="approvalRemediation"
                              value={updateIssueId.analyst_name}
                              onChange={handleChange("Approval")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                              disabled
                            />
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 mt-1">
                      <label className="cv-input-label">Comment</label>
                      <TextArea
                        name="Comment"
                        type="text"
                        placeholder="Please add comment"
                        value={comments}
                        onChange={handleChangeComment}
                        className="cv-input-field input-field-border"
                      />
                      {commentsFormat && (
                        <label className="requiredComments">
                          Only alphabets and some special characters are allowed
                          for this field
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 mt-1 ">
                      <label className="cv-input-label">Assessor Comment</label>
                      <TextArea
                        name="Comment"
                        type="text"
                        placeholder="Please add comment"
                        value={updateIssueId.assessorcomment}
                        onChange={handleChangeComment}
                        className="cv-input-field input-field-border"
                        readonly={true}
                      />
                      {commentsFormat && (
                        <label className="requiredComments">
                          Only alphabets and some special characters are allowed
                          for this field
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="options-container">
                    {updateIssueId &&
                      updateIssueId.title_action !== "" &&
                      View &&
                      View && (
                        <button
                          type="submit"
                          className="save-button m-l-2"
                          onClick={() => handleProvideResponse("8")}
                        >
                          Submit
                        </button>
                      )}
                    {View  && (
                      <button type="submit" className="save-button m-l-2">
                        Clarify
                      </button>
                    )}
                    <button
                      className="cancel-button m-l-2"
                      type="reset"
                      onClick={prop.handleBack}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
    </div>
  );
}
RemediationPlan.propTypes = {
  values:PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  handleSubmit:PropTypes.func
}
